require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-complete-artificial-intelligence-undergraduate-course-plan.json") })
        }
      }, "path---posts-complete-artificial-intelligence-undergraduate-course-plan");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-complete-artificial-intelligence-undergraduate-course-plan!./.cache/json/posts-complete-artificial-intelligence-undergraduate-course-plan.json
// module id = 371
// module chunks = 231608221292675